import Skeleton from "antd/lib/skeleton";
import React from "react";

const FacebookCallback = () => <Skeleton />;

export default FacebookCallback;
